const IntegrationPlatform = Object.freeze({
  TWILIO: 'Twilio',
  SEVEN_ROOMS: 'SevenRooms',
} as const);

export type IntegrationPlatform = (typeof IntegrationPlatform)[keyof typeof IntegrationPlatform];

export const allIntegrationPlatforms = Object.values(IntegrationPlatform) as [
  IntegrationPlatform,
  ...IntegrationPlatform[],
];

export default IntegrationPlatform;
